import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { USER_SESSION } from "../helper/SecurityHelper";
import * as securityHelper from "../helper/SecurityHelper";
import {
  fn_loginHandlerCallback,
  fn_retrieveTodayCmpnyWrkDclrJob,
  fn_retrieveTodayWrkDclrDtl,
} from "../api/FnCmmn";
import NavbarText from '../components/NavbarText';
import Footer from '../components/Footer';
import Snackbar from '../components/Snackbar';
import SearchCompany from "../components/signUp/SearchCompany";
import SelectSctrGb from "../components/signUp/SelectSctrGb";
import CmpnyTab from "../components/smartTBMList/CmpnyTab";
import EvalListTab from "../components/smartTBMList/EvalListTab";
import ExbtPlcTab from "../components/smartTBMList/ExbtPlcTab";
import { TBMEvntList } from "../interface/Interface";

export default function SmartTBMList() {
  const user = securityHelper.getLoginUser();
  const navigate = useNavigate();
  const location = useLocation();
  const isExbtPlc = location.state.exbtPlc;
  const wrkDclrList = location.state.wrkDclrList;
  const [tab, setTab] = useState('cmpny');
  const [selectedSctrGb, setSelectedSctrGb] = useState('');
  const [cmpnyListDatas, setCmpnyListDatas] = useState([]);
  const [companyName, setCompanyName] = useState('');
  const [cmpnySeq, setCmpnySeq] = useState<any>();
  const [evntList, setEvntList] = useState<TBMEvntList>({ '전시장1': null, '전시장2': null });
  const [listDatas, setListDatas] = useState([]);
  const [fileName, setFileName] = useState('');
  const fileRef = useRef() as React.MutableRefObject<any>;
  const fileHandler = () => { fileRef.current.click(); };
  const [selectedEvalList, setSelectedEvalList] = useState<number[]>([]);
  const [selectedExbtPlcList, setSelectedExbtPlcList] = useState<string[]>([]);
  const [evntSeq, setEvntSeq] = useState(0);
  const [snackbarTxt, setSnackbarTxt] = useState('');
  const [isSctrGbPopOpen, setIsSctrGbPopOpen] = useState(false);
  const [companyPopup, setCompanyPopup] = useState(false);

  useEffect(() => { if (isExbtPlc) { setTab('exbtPlc') }; }, []);
  useEffect(() => { if (wrkDclrList) { setTab('evalList') }; }, []);
  useEffect(() => { fn_retrieveRcntWrkDclrCmpnyList({ setCmpnyListDatas, user }); }, []);
  useEffect(() => { if (snackbarTxt) { setTimeout(() => setSnackbarTxt(''), 2000); } }, [snackbarTxt]);
  useEffect(() => { if (user.auth === 'SRV' && !isExbtPlc) { setTab('evalList'); } }, [user]);
  useEffect(() => { if (tab === 'exbtPlc') { fn_exbtPlcList(); } }, [tab]);
  // useEffect(() => { if (companyPopup === false && companyName === '무소속') { setIsSctrGbPopOpen(true); } }, [companyPopup]);
  // ** 작업자 권한으로 진행 **
  // useEffect(() => { if (user.auth === 'SRV' && (listDatas.length === 0 || authChange)) { srvAuthChange(); } }, [user, listDatas]);
  // const srvAuthChange = async () => {
  //   user.auth = 'WOK';
  //   user.authSeq = 4;
  //   sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
  //   await fn_loginHandlerCallback(user, navigate);
  //   return;
  // }

  const evalListCheckHandler = (seq: number) => {
    if (selectedEvalList.includes(seq)) {
      let temp = selectedEvalList.filter((e) => e !== seq);
      setSelectedEvalList([...temp]);
    } else {
      selectedEvalList.push(seq);
      setSelectedEvalList([...selectedEvalList]);
    }
  };
  const fn_exbtPlcList = async () => {
    const rtrnData = await fn_retrieveEvntSeqByExbtPlc();
    console.log("::::::" + rtrnData)
    setEvntList(rtrnData);
  }
  const exbtPlcHandler = (paramExbtPlc: string, paramEvntSeq: number) => {
    if (selectedExbtPlcList.includes(paramExbtPlc)) {
      let temp = selectedExbtPlcList.filter((exbtPlc: string) => exbtPlc !== paramExbtPlc);
      temp.length === 0 && setEvntSeq(0);
      setSelectedExbtPlcList(temp);
    } else {
      if (evntSeq !== 0 && evntSeq !== paramEvntSeq) { setSnackbarTxt('여러 행사를 동시에 신고할 수 없습니다. 장소를 확인해주세요.'); return; }
      setSelectedExbtPlcList(selectedExbtPlcList.concat(paramExbtPlc));
      setEvntSeq(paramEvntSeq)
    }
  };
  const backEvent = () => {
    // if (isExbtPlc || wrkDclrList) {
    //   if (window.confirm('TBM을 취소하고 로그아웃 하시겠습니까?')) {
    //     sessionStorage.removeItem(USER_SESSION);
    //     window.location.href = "/signUp"
    //     return;
    //   }
    // } else
    if (cmpnySeq === undefined) {
      sessionStorage.removeItem(USER_SESSION);
      window.location.href = "/signUp"
      return;
    } else {
      if (user.auth === 'WOK') {
        if (tab === 'cmpny') { navigate(-1) }
        else if (tab === 'evalList') { setTab('cmpny') }
        else if (tab === 'exbtPlc') { setTab('cmpny') }
      } else { navigate('/signUp') }
    }
  }

  const nextHandler = async () => {
    let paramCmpnySeq;
    // 업체 선택 화면
    if (tab === 'cmpny') {
      setCompanyPopup(false);
      if (companyName !== '') {
        // 회사의 신고서 리스트 가져오기 (신고서 1개 -> tbm 시작 // 신고서 2개 이상 -> 'evalList' // 없을 때 -> 'exbtPlc' 이동)
        fn_retrieveTodayWrkDclrList({ navigate, user, cmpnySeq, companyName, setTab, setListDatas });
      }
      // 신고서 선택화면
    } else if (tab === 'evalList') {
      if (selectedEvalList.length === 0) { setSnackbarTxt('신고서를 선택해 주십시오.'); return; };

      let wrkDclrDtlList: any = [];
      let wrkDclrSeqArr: any = [];
      let smartTbmSeqArr: any = [];
      let wrkDclrSeqStr;
      let smartTbmSeqStr;
      let smartTbmSeq;

      wrkDclrSeqArr = selectedEvalList;
      wrkDclrSeqStr = wrkDclrSeqArr.join();
      if (user.auth === 'SRV') {
        // tbm init register 하기
        wrkDclrDtlList = await fn_retrieveTodayWrkDclrDtl(wrkDclrSeqArr);
        // setTimeout(500) 레이스 제거: 모든 init POST를 await한 뒤 seq를 모아 넘긴다
        const srvRsltList = await Promise.all(wrkDclrDtlList.map((wrkDclrData: any) =>
          axios.post('admin/api/tbm/registInitSmrtTbmData', {
            userSeq: user.seq,
            authSeq: 3,
            cmpnySeq: wrkDclrData.cmpnySeq,
            evntSeq: wrkDclrData.evntSeq,
            sctrGb: wrkDclrData.sctrGb,
            wrkDclrSeq: wrkDclrData.wrkDclrSeq
          })
        ));
        smartTbmSeqArr = srvRsltList.map((r: any) => r.data);
        user.wrkDclrSeq = wrkDclrSeqStr;
        smartTbmSeqStr = smartTbmSeqArr.join();
        user.smartTbmSeq = smartTbmSeqStr;
        sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
        navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeqStr, wrkDclrList: wrkDclrDtlList, authChange: false } });
        // 작업자의 경우 유저 작업 history 저장하기 + 유저 companySeq 바꿔주기
      } else if (user.auth === 'WOK') {
        paramCmpnySeq = cmpnySeq;
        // 유저 작업 history 저장하기 + 유저 companySeq 바꿔주기
        if (isExbtPlc) {
          // 회원가입 : 최초 작업이기 때문에, 유저 작업 history 저장하기
          await axios.post("admin/api/tbm/changeUserCmpnyBlng", { userSeq: user.seq, cmpnySeq: user.companySeq })
        } else {
          // 유저 직전 회사 검색해서 다를 때 : 직전 회사 찾아오기
          const mostRcntCmpnySeq = await axios.post('admin/api/tbm/retrieveMostRcntCmpnySeq', { userSeq: user.seq });
          console.log(mostRcntCmpnySeq.data.cmpnySeq)
          console.log(paramCmpnySeq)
          if (mostRcntCmpnySeq.data.cmpnySeq !== paramCmpnySeq) {
            await axios.post("admin/api/tbm/changeUserCmpnyBlng", { userSeq: user.seq, cmpnySeq: paramCmpnySeq })
            user.companySeq = paramCmpnySeq;
            sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
          }
        };
        // tbm init register 하기
        wrkDclrDtlList = await fn_retrieveTodayWrkDclrDtl(wrkDclrSeqArr);
        // setTimeout(500) 레이스 제거: 모든 init POST를 await한 뒤 seq를 모아 넘긴다
        const wokRsltList = await Promise.all(wrkDclrDtlList.map((wrkDclrData: any) =>
          axios.post('admin/api/tbm/registInitSmrtTbmData', {
            userSeq: user.seq,
            authSeq: 4,
            cmpnySeq: wrkDclrData.cmpnySeq,
            evntSeq: wrkDclrData.evntSeq,
            sctrGb: wrkDclrData.sctrGb,
            wrkDclrSeq: wrkDclrData.wrkDclrSeq,
            userNm: user.name,
            userPhone: user.phone
          })
        ));
        smartTbmSeqArr = wokRsltList.map((r: any) => r.data);
        user.wrkDclrSeq = wrkDclrSeqStr;
        smartTbmSeqStr = smartTbmSeqArr.join();
        user.smartTbmSeq = smartTbmSeqStr;
        sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
        navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeqStr, wrkDclrList: wrkDclrDtlList, authChange: false } });
      };
    } else if (tab === 'exbtPlc') {
      if (!evntSeq) { setSnackbarTxt('장소를 선택해주세요.'); return; }
      let paramEvntSeq = evntSeq;
      let paramCmpnyNm = companyName;
      let sctrGbCd;
      let authChange = false;
      if (cmpnySeq === undefined) { sctrGbCd = user.sctrGbCd.split(',')[0]; paramCmpnyNm = user.companyName; paramCmpnySeq = user.companySeq; authChange = true; }
      else {
        if (selectedSctrGb !== '') {
          sctrGbCd = selectedSctrGb
        } else {
          paramCmpnyNm = user.companyName;
          paramCmpnySeq = user.companySeq;
          const rtrnData = await axios.post('admin/api/cmpny/cmpnyDtl/retrieveCmpnySctrGbCd', {cmpnySeq:paramCmpnySeq});
          sctrGbCd = rtrnData.data.sctrGb.split(',')[0]
        }
      }
      if (paramCmpnyNm === '무소속') {
        const rtrnData = await axios.post('admin/api/sgst/retrieveNonBlngCmpnySeq', { sctrGbCd: sctrGbCd });
        paramCmpnySeq = rtrnData.data;
      } else {
        if(cmpnySeq !== undefined) {
          // 유저 직전 회사 검색해서 다를 때 : 직전 회사 찾아오기
          const mostRcntCmpnySeq = await axios.post('admin/api/tbm/retrieveMostRcntCmpnySeq', { userSeq: user.seq });
          if (!paramCmpnySeq) { paramCmpnySeq = user.companySeq }
          if (mostRcntCmpnySeq.data.cmpnySeq !== paramCmpnySeq) {
            await axios.post("admin/api/tbm/changeUserCmpnyBlng", { userSeq: user.seq, cmpnySeq: paramCmpnySeq })
          }
        }
      }
      const smartTbmSeq = await axios.post('admin/api/tbm/registInitSmrtTbmData', {
        userSeq: user.seq,
        tbmPrcsStat: '002',
        authSeq: 4,
        cmpnySeq: paramCmpnySeq,
        evntSeq: paramEvntSeq,
        sctrGb: sctrGbCd,
        userNm: user.name,
        userPhone: user.phone
      })
      user.companyName = paramCmpnyNm;
      user.companySeq = paramCmpnySeq;
      user.wrkDclrSeq = 0;
      user.smartTbmSeq = smartTbmSeq.data;
      sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
      navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeq.data, noneWrkDclr: true, evntSeq, sctrGb: sctrGbCd, selectedExbtPlcList, authChange } })
    }
  };
  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {isSctrGbPopOpen && <SelectSctrGb selectedSctrGb={selectedSctrGb} setSelectedSctrGb={setSelectedSctrGb} setIsSctrGbPopOpen={setIsSctrGbPopOpen} setSnackbarTxt={setSnackbarTxt} setCompanyName={setCompanyName} setCmpnySeq={setCmpnySeq} setTab={setTab} tbmList />}
      {companyPopup && <SearchCompany setTab={setTab} setCompanyName={setCompanyName} setCompanyPopup={setCompanyPopup} companyName={companyName} setCmpnySeq={setCmpnySeq} selectedSctrGb={selectedSctrGb} setSnackbarTxt={setSnackbarTxt} nextHandler={nextHandler} auth={user.auth} tbmList />}
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      <NavbarText backEvent={backEvent}>업체선택</NavbarText>
      <div className='bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-116px)] md:h-[calc(100%-290px)] '>
        <div className='mb-20 md:mb-[50px] w-[85%]'>
          {tab === 'cmpny' && <div className='flex items-center justify-between mt-33 text-15 leading-18 md:mt-82 md:text-37 md:leading-45'>
            <p className='ml-8 md:ml-20'>업체 선택</p>
          </div>}
          {tab === 'cmpny' && <CmpnyTab user={user} cmpnyListDatas={cmpnyListDatas} setCompanyName={setCompanyName} cmpnySeq={cmpnySeq} setCmpnySeq={setCmpnySeq} fileRef={fileRef} fileName={fileName} setFileName={setFileName} fileHandler={fileHandler} setCompanyPopup={setCompanyPopup} setIsSctrGbPopOpen={setIsSctrGbPopOpen} setSelectedSctrGb={setSelectedSctrGb} setTab={setTab} tbmList/>}
          {tab === 'evalList' && <EvalListTab wrkDclrList={wrkDclrList} listDatas={listDatas} setListDatas={setListDatas} evalListCheckHandler={evalListCheckHandler} selectedEvalList={selectedEvalList} />}
          {tab === 'exbtPlc' && <ExbtPlcTab exbtPlcHandler={exbtPlcHandler} selectedExbtPlcList={selectedExbtPlcList} evntList={evntList} />}
        </div>
        {((tab === 'cmpny' && cmpnySeq) || tab !== 'cmpny') && <button onClick={nextHandler} className='font-preLight text-15 md:text-37 text-white w-[260px] sm:w-[318px] md:w-[795px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto mb-20 py-10 md:mb-[50px] md:py-[25px]'>TBM 시작</button> }
      </div>
      <Footer />
    </div>
  );
}

/** 최근 작업한 5개 업체 목록 가져오기 **/
const fn_retrieveRcntWrkDclrCmpnyList = async ({ setCmpnyListDatas, user }: any) => {
  const rtrnData = await axios.post('admin/api/login/retrieveRcntPtcptCmpnyList', { userSeq: user.seq });
  setCmpnyListDatas(rtrnData.data);
}

/** 작업신고서 목록 가져오기 **/
const fn_retrieveTodayWrkDclrList = async ({ navigate, user, cmpnySeq, companyName, setTab, setListDatas }: any) => {
  let wrkDclrSeqArr: any = [];
  let paramSelCmpny = cmpnySeq;
  let paramCmpnyNm = companyName;

  const wrkDclrListCmpnyWok = await fn_retrieveTodayCmpnyWrkDclrJob(user.seq, paramSelCmpny);
  wrkDclrListCmpnyWok.map((wrkDclrData: any) => {
    wrkDclrSeqArr.push(wrkDclrData.wrkDclrSeq);
  });

  // 작업 신고서 1개일 때, TBM으로 바로 이동
  if (wrkDclrListCmpnyWok.length === 1) {
    let wrkDclrData = wrkDclrListCmpnyWok[0];
    // 유저 직전 회사 검색해서 다를 때 : 직전 회사 찾아오기
    const mostRcntCmpnySeq = await axios.post('admin/api/tbm/retrieveMostRcntCmpnySeq', { userSeq: user.seq });
    // 유저 작업 history 저장하기 + 유저 companySeq 바꿔주기
    if (mostRcntCmpnySeq.data.cmpnySeq !== paramSelCmpny) {
      await axios.post("admin/api/tbm/changeUserCmpnyBlng", { userSeq: user.seq, cmpnySeq: paramSelCmpny });
      user.companySeq = paramSelCmpny;
      user.companyName = paramCmpnyNm;
      sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
    }
    // tbm init register 하기
    const smartTbmSeq = await axios.post('admin/api/tbm/registInitSmrtTbmData', {
      userSeq: user.seq,
      authSeq: 4,
      cmpnySeq: paramSelCmpny,
      evntSeq: wrkDclrData.evntSeq,
      sctrGb: wrkDclrData.sctrGb,
      wrkDclrSeq: wrkDclrData.wrkDclrSeq,
      userNm: user.name,
      userPhone: user.phone
    })
    user.wrkDclrSeq = wrkDclrData.wrkDclrSeq;
    user.smartTbmSeq = smartTbmSeq.data;
    sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
    navigate('/smart-TBM', { state: { smartTbmSeq: smartTbmSeq.data, wrkDclrList: wrkDclrListCmpnyWok, authChange: false } })
    // 작업 신고서 2개 이상일 때, TBM list 작업 선택 화면으로 이동
  } else if (wrkDclrListCmpnyWok.length > 1) {
    setListDatas(wrkDclrListCmpnyWok);
    setTab('evalList');
    // 회사의 작업 신고서가 없을 때 : 전시장소 선택화면으로 이동(행사 선택)
  } else if (wrkDclrListCmpnyWok.length === 0) {
    setTab('exbtPlc');
  }
};

/**
 * 건설기초안전 이수증 저장
 */
const fn_registCnstrAtchFile = async ({ fileRef, user }: any) => {
  const fileList = fileRef.current.files;
  const formData = new FormData();

  if (fileList.length > 0) {
    formData.append('multipartFiles', fileList[0]);
    const jsonObject = { userSeq: user.seq };
    formData.append('jsonData', JSON.stringify(jsonObject));
    const rtrnData = await axios.post('admin/api/login/registCnstrAtchFile', formData);
    if (rtrnData.data) {
      user.cnstrAtchFileId = rtrnData.data;
      sessionStorage.setItem(securityHelper.USER_SESSION, JSON.stringify(user));
      window.location.reload()
    }
  }
};

/**
 * 행사 위치로 행사 정보 가져오기
 */
const fn_retrieveEvntSeqByExbtPlc = async () => {
  const rtrnData = await axios.post('admin/api/tbm/retrieveEvntSeqByExbtPlc');
  return rtrnData.data;
}
